import { BulletListStyle } from '../types';

export type PersonalLoansItems = {
  qualificationsBullets: string[];
  availableTermLengths: string;
  feesBullets: string[];
  disclaimer: string;
};

export function getPersonalLoansItems(
  selectedOffer: any
): PersonalLoansItems | undefined {
  if (!selectedOffer) {
    return undefined;
  }

  const qualificationsBullets = selectedOffer.qualificationsBullets || [];
  const availableTermLengths = selectedOffer.availableTermLengths || '';
  const feesBullets = selectedOffer.feesBullets || [];
  const disclaimer = selectedOffer.disclaimer || '';

  return {
    qualificationsBullets,
    availableTermLengths,
    feesBullets,
    disclaimer,
  };
}

export function personalLoans({
  qualificationsBullets = [],
  availableTermLengths = '',
  feesBullets = [],
  disclaimer = '',
  listStyleType = 'none',
}: {
  qualificationsBullets: string[];
  availableTermLengths: string;
  feesBullets: string[];
  disclaimer: string;
  listStyleType: BulletListStyle;
}) {
  const paddingLeft = listStyleType === 'none' ? '0' : '1.2em';
  const fontSize = 13;
  return (
    <div>
      <strong>Qualifications</strong>
      <ul style={{ listStyleType, paddingLeft }}>
        {qualificationsBullets?.map((item) => (
          <li key={item} style={{ fontSize }}>
            {item}
          </li>
        ))}
      </ul>
      <strong>Available Term Lengths</strong>
      <ul style={{ listStyleType, paddingLeft }}>
        <li style={{ fontSize }}>{availableTermLengths}</li>
      </ul>
      <strong>Fees</strong>
      <ul style={{ listStyleType, paddingLeft }}>
        {feesBullets?.map((item) => (
          <li key={item} style={{ fontSize }}>
            {item}
          </li>
        ))}
      </ul>
      <span style={{ fontSize }}>Disclaimer: {disclaimer}</span>
    </div>
  );
}
